export default __webpack_public_path__ + "static/media/ETEF-22.6579c597.pdf";